import React from 'react';
import { FormattedMessage } from 'react-intl';
import { useEntityTotals } from '@printdeal/checkout-frontend';
import { Money } from '../../../../Money';
import { SanitizedOrder } from '../../../../../types/order/Order';

interface OrderShippingCostsProps {
  order: SanitizedOrder;
}

const OrderShippingCosts = ({
  order,
}: OrderShippingCostsProps) => {
  // @ts-expect-error type mismatch
  const { entityTotal } = useEntityTotals({ entity: order });

  return (
    <div className="pd-flex pd-gap-4">
      <div className="pd-grow pd-font-bold">
        <FormattedMessage id="account.order.shippingcost.title" defaultMessage="Shipping costs" />
      </div>
      <div>
        {entityTotal?.shipping.basePrice?.totalNet.centAmount === undefined ? (
          <span className="pd-font-bold pd-text-success-600">
            <FormattedMessage id="checkout.payment.option.free" defaultMessage="Free" />
          </span>
        ) : (
          <Money
            value={entityTotal.shipping.basePrice.totalNet.centAmount ?? 0}
            currency={entityTotal.shipping.basePrice.totalNet.currencyCode}
          />
        )}
      </div>
    </div>
  );
};

export default OrderShippingCosts;
